import React, { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/material";
import { Page, Header, MUITable } from "components";
import { codeDesc, getDesc } from "utilities";
import { useTranslation } from "react-i18next";

const PREFIX = 'RouteList';

const classes = {
  root: `${PREFIX}-root`
};

const StyledPage = styled(Page)((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  }
}));

function RouteList() {

  const navigate = useNavigate();
  const [codes, setCodes] = useState(null);

  const { t } = useTranslation("route");

  const columns = [
    {
      label: t("Plant"),
      name: "plant",
      options: { customBodyRender: (value) => getDesc(codes, "plant", value) },
    },
    { label: t("Route"), name: "route" },
    { label: t("Description"), name: "name" },
    { label: t("Target Visits"), name: "targetvisitnum" },
  ];

  const handleRowClick = (rowdata) => {
    navigate("/app/route/" + rowdata[0] + "/" + rowdata[1]);
    console.log(rowdata);
  };

  const handleAddClick = () => {
    navigate("/app/route/-");
  };

  useEffect(() => {
    codeDesc("en", ["plant"]).then((res) => {
      setCodes(res);
    });
  }, []);

  if (!codes) {
    return null;
  }

  return (
    <StyledPage className={classes.root} title={"Routes"}>
      <Container maxWidth={false} className={classes.container}>
        <Header
          title={t("Management")}
          subtitle={t("Routes")}
          addFunc={handleAddClick}
        />
        <MUITable
          endpoint="/api/routes"
          cols={columns}
          onRowClick={handleRowClick}
          name={"route"}
        />
      </Container>
    </StyledPage>
  );
}

export default RouteList;
